import React from 'react';
import { Dialog, DialogActions, DialogTitle } from '@mui/material';
import Button from 'react-bootstrap/Button';
import { useUpdateOrderStatusMutation } from '../../../features/Dispatch/TripDispatchSlice';
import { toast } from 'react-toastify';
   
const RemoveDriverCheckbox = (props) => {
    const [updateOrderStatus] = useUpdateOrderStatusMutation();
    
    const statusCodeMap = {
        'P': 'Pickup',
        'PX': 'Pickup Cross Dock',
        'DX': 'Delivery Cross Dock',
        'OD': 'Out for Delivery',
        'D': 'Delivery',
    }

    const statusMap = {
        'O': 'Open',
        'L': 'Loading',
        'OUT': 'Outbound',
        'IN': 'Inbound',
        'C': 'Completed',
    }
    
    const handleConfirm = async () => {    
        const body = {
            orderId: props.orderID,
            orderNumber: props.orderNumber,
            divisionId: props.divisionId,
            outTime: null,
            isChecked: false,
            orderStatusCode: props.orderStatusCode
        };
        const result = await updateOrderStatus(body)
        if (result.data?.statusCode === 200) {
            toast.success(result.data.data.message , { position: 'top-center' });
            props.setShowRemoveDriverCheckbox(false);
            props.getAllOpenTripOrders(props.divisionId);
            if (props.selectedTrip) {
                props.getTripOrdersClassification({ tripStatus: statusMap[props.selectedTrip?.tripStatusCode], tripId: props.selectedTrip?.tripID, divisionId: props.divisionId })
            }
        } else {
            toast.error(result?.error.data?.data?.message, { position: 'top-center' });
        }
    };

    return (
        <Dialog open={props.showRemoveDriverCheckbox} onClose={() => props.setShowRemoveDriverCheckbox(false)}>
            <DialogTitle  style={{backgroundColor: '#bf2527', color: 'white'}}>Are you sure you want to undo the "{statusCodeMap[props.orderStatusCode]}" status?</DialogTitle>
            <DialogActions>
                <Button className='btn-secondary' onClick={() => props.setShowRemoveDriverCheckbox(false)}>Cancel</Button>
                <Button className="btn-primary" onClick={handleConfirm}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default RemoveDriverCheckbox;
